import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareHeaders } from '../../configuration/tokenHandling/prepareHeaders';
import * as api from './generated/api';

const baseUrl = `${import.meta.env.VITE_IOT_DATA_QUALITY_MONITOR_URL}`;
export const statisticsApi = createApi({
    reducerPath: 'statisticsApi',
    baseQuery: fetchBaseQuery({ prepareHeaders }),
    endpoints: builder => ({
        getStatisticsForStream: builder.query<api.Statistics, string>({
            query: streamId => ({ url: `${baseUrl}/streams/${streamId}/statistics` }),
            transformResponse: (x: unknown) => api.Statistics.parse(x),
        }),
    }),
});

export const { useLazyGetStatisticsForStreamQuery } = statisticsApi;
